import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CreateWorkLocationAssignmentMutationVariables = Types.Exact<{
  input: Types.CreateWorkLocationAssignmentInput
}>

export type CreateWorkLocationAssignmentMutation = {
  __typename?: 'Mutation'
  createWorkLocationAssignment?: {
    __typename?: 'CreateWorkLocationAssignmentPayload'
    workLocationAssignment?: {
      __typename?: 'WorkLocationAssignment'
      id: number
      employer: { __typename?: 'Employer'; id: number; name?: string | null }
      workLocation: { __typename?: 'WorkLocation'; id: number; name: string }
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CreateWorkLocationAssignmentDocument = `
    mutation CreateWorkLocationAssignment($input: CreateWorkLocationAssignmentInput!) {
  createWorkLocationAssignment(input: $input) {
    workLocationAssignment {
      id
      employer {
        id
        name
      }
      workLocation {
        id
        name
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useCreateWorkLocationAssignmentMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    CreateWorkLocationAssignmentMutation,
    TError,
    CreateWorkLocationAssignmentMutationVariables,
    TContext
  >
) =>
  useMutation<
    CreateWorkLocationAssignmentMutation,
    TError,
    CreateWorkLocationAssignmentMutationVariables,
    TContext
  >(
    ['CreateWorkLocationAssignment'],
    (variables?: CreateWorkLocationAssignmentMutationVariables) =>
      fetchGql<CreateWorkLocationAssignmentMutation, CreateWorkLocationAssignmentMutationVariables>(
        CreateWorkLocationAssignmentDocument,
        variables
      )(),
    options
  )
